import { Post } from 'apps/shared/scripts/__generated__/graphql.generated';
import { useIsOwner } from 'apps/shared/scripts/hooks';

import CardPostActions from './CardPostActions';
import CardPostMedia from './CardPostMedia';
import CardPostMessage from './CardPostMessage';
import CardPostProfile from './CardPostProfile';
import { cardPostClassName } from './styles';

type Props = Post & { isCardDelivered?: boolean; isCardOwner?: boolean };

const CardPost = ({
  author,
  id,
  media,
  message,
  name,
  isCardOwner,
  isCardDelivered,
}: Props) => {
  const isPostOwner = useIsOwner(author?.id);

  return (
    <div className={cardPostClassName}>
      <CardPostMedia media={media} />
      <CardPostMessage message={message} />
      <CardPostProfile name={name} />
      <CardPostActions
        id={id}
        isCardDelivered={isCardDelivered}
        isCardOwner={isCardOwner}
        isPostOwner={isPostOwner}
      />
    </div>
  );
};

CardPost.displayName = 'CardPost';

export default CardPost;
